import React from 'react';
import { Icons } from '../../../components/atoms/SVG';
import Btn, { BtnModifier } from '../../../components/molecules/Btn';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { TooltipPlacement } from '../../../components/atoms/Tooltip';

export function AToZToNavButton({ id, hint }: { id: string; hint: string }) {
  const { t } = useSonTranslation('AToZContainer');

  return (
    <div className="a-to-z-container__character-group">
      <strong className="a-to-z-container__character-heading">
        <span className="invisible">{hint}</span>
        {id.toUpperCase()}
      </strong>
      <div className="a-to-z-container__table-jump-to-list-button">
        <Btn
          id={`char-${id}`}
          tooltipPlacement={TooltipPlacement.RIGHT}
          text={t('charactergroup.backToTop.title')}
          titleText={t('charactergroup.backToTop.title')}
          hiddenText
          svgSpriteId={Icons.UP_CIRCLE_ARROW_FULL}
          href={`#navigation-item-${id}`}
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
        />
      </div>
    </div>
  );
}
